"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_model_1 = require("../base/base.model");
class UserModel extends base_model_1.BaseModel {
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            companyName: 'CompanyName',
            email: 'Email',
            firstName: 'FirstName',
            fullName: 'Name',
            isActive: 'IsActive',
            lastName: 'LastName',
            phone: 'Phone',
            phoneCell: 'MobilePhone',
            profileId: 'ProfileId',
            smallPhotoUrl: 'SmallPhotoUrl',
            title: 'Title',
            userRoleId: 'UserRoleId'
        };
    }
}
exports.UserModel = UserModel;
//# sourceMappingURL=user.model.js.map